<template>
    <div class="width-a">
        <div class="navigate">
            <span>首页 > </span><span>公开资源 > </span
            ><span>{{ openResourceDetail.resourceName }} > </span>
        </div>
        <h1 class="title">{{ openResourceDetail.resourceName }}</h1>
        <div class="fr">
            <video
                class="img-a"
                ref="localVideo"
                :src="openResourceDetail.fileUrl | fileFilter"
                controls
            ></video>
            <div class="content">
                <span class="txt-a">课程简介</span>
                <p class="txt-b">{{ openResourceDetail.introduce }}</p>
                <p>
                    <a
                        class="txt-e"
                        v-if="openResourceDetail.downloadUrl"
                        :href="openResourceDetail.downloadUrl | fileFilter"
                        >资料下载</a
                    >
                </p>
                <ul class="frc">
                    <li>
                        <span class="txt-c"
                            >{{ openResourceDetail.clickCount || 0 }}人观看</span
                        >
                    </li>
                    <template v-if="isToken">
                        <li
                            class="collected"
                            v-show="openResourceDetail.collected == 0"
                            @click="collectTap"
                        >
                            <img src="@/assets/stara.png" alt="" />
                            <span class="txt-d">收藏</span>
                        </li>
                        <li
                            class="collected"
                            v-show="openResourceDetail.collected == 1"
                            @click="collectTap"
                        >
                            <img src="@/assets/starb.png" alt="" />
                            <span class="txt-d">已收藏</span>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
        <div style="height: 64px"></div>
    </div>
</template>

<script>
import Auth from "@/utils/Auth";
import HttpConnectionC from "@/utils/HttpConnectionC";
import CommonFilters from "@/mixins/CommonFilters";
export default {
    name: "OpenResourceDetail",
    mixins: [CommonFilters],
    data() {
        return {
            openResourceDetail: {},
            // count: 0, // 播放时间计数
            isToken: Auth.getToken(),
        };
    },
    mounted() {
        this.queryData();
    },
    methods: {
        queryData() {
            let that = this;
            let _id = that.$route.query.resourceData;
            HttpConnectionC.get(`/openresource/read/${_id}`).then(function (
                response
            ) {
                that.openResourceDetail = response.data;
            });
            that.HttpConnection.put(`/openresource/clickCount/${_id}`);
        },
        collectTap() {
            let that = this;
            let _resId = that.openResourceDetail.resourceId;
            let _userId = that.$store.state.user.userInfo.userId;
            if (that.openResourceDetail.collected == 0) {
                that.HttpConnection.post("/openresource/collect/save", {
                    userId: _userId,
                    resourceId: _resId,
                }).then(function (response) {
                    that.queryData();
                });
            } else if (that.openResourceDetail.collected == 1) {
                that.HttpConnection.post("/openresource/collect/delete", {
                    userId: _userId,
                    resourceId: _resId,
                }).then(function (response) {
                    that.queryData();
                });
            }
        },
        //   // 视频超过十分钟暂停
        //   ManageVideo () {
        //     let that = this;
        //     this.$refs.localVideo.onplay = function () {
        //       that.videoInterval();
        //     };
        //   },
        //   videoInterval () {
        //     let that = this
        //     var videoTime = setInterval(() => {
        //       that.count++;
        //       if (that.count > 600) {
        //         that.$refs.localVideo.pause()
        //         that.$refs.localVideo.onpause = function () {
        //           that.count = 0
        //           window.clearInterval(videoTime)
        //           alert("视频暂停播放,请点击继续");
        //         };
        //       }
        //     }, 1000);
        //     that.$refs.localVideo.onpause = function () {
        //       that.count = 0
        //       window.clearInterval(videoTime)
        //     };
        //   },
    },
};
</script>

<style scoped lang="scss">
.navigate {
    font-size: 14px;
    font-weight: 400;
    color: #4d4d4d;
}

.title {
    font-size: 32px;
    font-weight: 400;
    color: #000000;
    margin: 8px 0px 20px 0px;
}

.img-a {
    width: 900px;
    height: 505px;
}

.content {
    width: 280px;
    height: 505px;
    background-color: #f2f2f2;
    padding: 32px 16px;
}

.collected {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    margin: 0px 0px 0px 20px;
}

.txt-a {
    font-size: 20px;
    font-weight: 400;
    color: #000000;
}

.txt-b {
    height: 360px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #333333;
    margin: 24px 0px 0px 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 15;
    -webkit-box-orient: vertical;
}

.txt-c {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin: 0px 16px 0px 0px;
}

.txt-d {
    font-size: 14px;
    font-weight: 400;
    color: #91a9ff;
}

.txt-e {
    font-size: 14px;
    font-weight: 400;
    color: #91a9ff;
}
</style>
